import React, { useState, useEffect } from 'react';
import { fetchData, UploadData } from './axios_URL';
import Login from './Auth/Login';
import HomePage from './Home/Homepage';
import Request from './Home/Requests';
import Archive from './Home/Archive';
import ChatSupport from './Home/ChatSupport';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './Bar/Sidebar';


// App Component
const App = () => {
    // Initialize as null, not "null" (string)
    const [loggedInUser, setLoggedInUser] = useState(localStorage.getItem('username'));
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);
    const [totalCompanies, setTotalCompanies] = useState(0);
    const [unreadMessages, setUnreadMessages] = useState(0);
    const [unactivecompany, setUnactivecompany] = useState(0);


    useEffect(() => {
        const getCompanies = async () => {
            try {
                const response = await fetchData("GET", "/api/admin/companies/badge/count");

                if (response.data) {
                   setTotalCompanies(response.data.totalCompanies || 0);
                   setUnreadMessages(response.data.unreadMessages || 0);
                   setUnactivecompany(response.data.unactivecompany || 0);
                }
            } catch (error) {
                console.error("Error fetching badge counts:", error);
            }
        };

        getCompanies();
    }, []);


    const handleLogout = () => {
        setShowLogoutPopup(true);
    };
    const confirmLogout = () => {
        localStorage.removeItem('username');
        localStorage.removeItem('password');
        window.location.href = '/login'; // Redirect to login page
    };

    const cancelLogout = () => {
        setShowLogoutPopup(false);
    };

    return (
        <div className="home-page">
 
            {loggedInUser ? (
                <>
                    <Sidebar onLogout={handleLogout} totalCompanies={totalCompanies} unreadMessages={unreadMessages} unactivecompany={unactivecompany}/>
                    <Routes>
                    <Route path="/requests" element={<Request  />} />
                    <Route path="/archive" element={<Archive  />} />
                    <Route path="/support" element={<ChatSupport  />} />
                        <Route path="*" element={<HomePage username={loggedInUser} />} />
                    </Routes>
                </>
            ) : (
                <Login onLogin={setLoggedInUser} />
            )}


            {showLogoutPopup && (
                <div className="logout-popup">
                    <div className="popup-content">
                        <div className='AddEmployeeHeader'>
                            Bist du sicher, dass du dich abmelden möchtest?
                        </div>

                        <button onClick={confirmLogout}>Ja</button>
                        <button onClick={cancelLogout}>Nein</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default App;
